export const SEND_ADMIN_EMAIL = "SEND_ADMIN_EMAIL"
export const GET_SELECTED_RECIPIENTS = "GET_SELECTED_RECIPIENTS"
export const RECEIVE_SELECTED_RECIPIENTS = "RECEIVE_SELECTED_RECIPIENTS"
export const CLEAR_SELECTED_RECIPIENTS = "CLEAR_SELECTED_RECIPIENTS"
export const UPDATE_RECIPIENTS = "UPDATE_RECIPIENTS"
export const UPDATE_ADMIN_EMAIL_TYPE = "UPDATE_ADMIN_EMAIL_TYPE"
export const TURN_OFF_LOADING_RECIPIENTS = "TURN_OFF_LOADING_RECIPIENTS"
export const UPDATE_FROM_NAME = "UPDATE_FROM_NAME"
export const TOGGLE_ONBOARD_AS_ADMIN = "TOGGLE_ONBOARD_AS_ADMIN"
export const TOGGLE_INCLUDE_INVITED_MEMBERS = "TOGGLE_INCLUDE_INVITED_MEMBERS"
export const TOGGLE_DISABLE_REMINDER = "TOGGLE_DISABLE_REMINDER"
export const ADD_TEST_RECIPIENT = "ADD_TEST_RECIPIENT"
export const CLEAR_TEST_RECIPIENT = "CLEAR_TEST_RECIPIENT"
export const TURN_ON_TEST_EMAIL_SENT = "TURN_ON_TEST_EMAIL_SENT"
export const TURN_OFF_TEST_EMAIL_SENT = "TURN_OFF_TEST_EMAIL_SENT"
export const TURN_ON_TEST_EMAIL_SENDING = "TURN_ON_TEST_EMAIL_SENDING"
export const TURN_OFF_TEST_EMAIL_SENDING = "TURN_OFF_TEST_EMAIL_SENDING"
export const UPDATE_REMINDER_EMAIL_DELAY_IN_DAYS = "UPDATE_REMINDER_EMAIL_DELAY_IN_DAYS"
export const CHANGE_REMINDER_SUBJECT = "CHANGE_REMINDER_SUBJECT"
export const CHANGE_REMINDER_BODY = "CHANGE_REMINDER_BODY"
export const GET_OUTBOUND_MESSAGES = "GET_OUTBOUND_MESSAGES"
export const RECEIVE_OUTBOUND_MESSAGES = "RECEIVE_OUTBOUND_MESSAGES"
export const FETCH_EMAIL_DRAFTS = "FETCH_EMAIL_DRAFTS"
export const RECEIVE_EMAIL_DRAFTS = "RECEIVE_EMAIL_DRAFTS"
export const ADD_EMAIL_DRAFT = "ADD_EMAIL_DRAFT"
export const ADD_EMAIL_DRAFT_SUCCESS = "ADD_EMAIL_DRAFT_SUCCESS"
export const DELETE_EMAIL_DRAFT = "DELETE_EMAIL_DRAFT"
export const DELETE_EMAIL_DRAFT_SUCCESS = "DELETE_EMAIL_DRAFT_SUCCESS"
export const UPDATE_DRAFT_ID = "UPDATE_DRAFT_ID"
export const UPDATE_EMAIL_DRAFT = "UPDATE_EMAIL_DRAFT"
export const UPDATE_EMAIL_DRAFT_SUCCESS = "UPDATE_EMAIL_DRAFT_SUCCESS"

export const sendAdminEmail = (params, success, error) => ({
  type: SEND_ADMIN_EMAIL,
  params,
  success,
  error,
})

export const addTestRecipient = (testRecipient) => ({
  type: ADD_TEST_RECIPIENT,
  testRecipient,
})

export const clearTestRecipient = () => ({
  type: CLEAR_TEST_RECIPIENT,
})

export const updateFromName = (fromName) => ({
  type: UPDATE_FROM_NAME,
  fromName,
})

export const toggleOnboardAsAdmin = () => ({
  type: TOGGLE_ONBOARD_AS_ADMIN,
})

export const toggleIncludeInvitedMembers = () => ({
  type: TOGGLE_INCLUDE_INVITED_MEMBERS,
})

export const toggleDisableReminder = () => ({
  type: TOGGLE_DISABLE_REMINDER,
})

export const updateReminderEmailDelayInDays = (reminderEmailDelayInDays) => ({
  type: UPDATE_REMINDER_EMAIL_DELAY_IN_DAYS,
  reminderEmailDelayInDays,
})

export const turnOffLoadingRecipients = () => ({
  type: TURN_OFF_LOADING_RECIPIENTS,
})

export const getSelectedRecipients = (recipientIds, success, error) => ({
  type: GET_SELECTED_RECIPIENTS,
  recipientIds,
  success,
  error,
})

export const receiveSelectedRecipients = (recipients, hasLargeNumRecp, success, error) => ({
  type: RECEIVE_SELECTED_RECIPIENTS,
  recipients,
  hasLargeNumRecp,
  success,
  error,
})

export const changeReminderSubject = (reminderEmailSubject) => ({
  type: CHANGE_REMINDER_SUBJECT,
  reminderEmailSubject,
})

export const changeReminderBody = (reminderEmailBody) => ({
  type: CHANGE_REMINDER_BODY,
  reminderEmailBody,
})

export const clearSelectedRecipients = () => ({
  type: CLEAR_SELECTED_RECIPIENTS,
})

export const updateRecipients = (validRecipients) => ({
  type: UPDATE_RECIPIENTS,
  validRecipients,
})

export const updateAdminEmailType = (adminEmailType) => ({
  type: UPDATE_ADMIN_EMAIL_TYPE,
  adminEmailType,
})

export const turnOnTestEmailSent = () => ({
  type: TURN_ON_TEST_EMAIL_SENT,
})

export const turnOffTestEmailSent = () => ({
  type: TURN_OFF_TEST_EMAIL_SENT,
})

export const turnOnTestEmailSending = () => ({
  type: TURN_ON_TEST_EMAIL_SENDING,
})

export const turnOffTestEmailSending = () => ({
  type: TURN_OFF_TEST_EMAIL_SENDING,
})

export const getOutboundMessages = (page, pageSize, success, error) => ({
  type: GET_OUTBOUND_MESSAGES,
  page,
  pageSize,
  success,
  error,
})

export const receiveOutboundMessages = (resp) => ({
  type: RECEIVE_OUTBOUND_MESSAGES,
  resp,
})

export const fetchEmailDrafts = (constituentId) => ({
  type: FETCH_EMAIL_DRAFTS,
  constituentId,
})

export const receiveEmailDrafts = (emailDraftsResponse) => ({
  type: RECEIVE_EMAIL_DRAFTS,
  emailDraftsResponse,
})

export const addEmailDraft = (params, success, error) => ({
  type: ADD_EMAIL_DRAFT,
  params, // refer to controllers/email/admin/email_drafts
  success,
  error,
})

export const addEmailDraftSuccess = (draftAddedResponse) => ({
  type: ADD_EMAIL_DRAFT_SUCCESS,
  draftAddedResponse, // {'draftAdded': newDraft}
})

export const deleteEmailDraft = (constituentId, draftId, success, error) => ({
  type: DELETE_EMAIL_DRAFT,
  params: { constituentId, draftId },
  success,
  error,
})

export const deleteEmailDraftSuccess = (draftId) => ({
  type: DELETE_EMAIL_DRAFT_SUCCESS,
  draftId,
})

export const updateDraftId = (draftId) => ({
  type: UPDATE_DRAFT_ID,
  draftId,
})

export const updateEmailDraft = (params, success, error) => ({
  type: UPDATE_EMAIL_DRAFT,
  params, // refer to controllers/email/admin/email_drafts
  success,
  error,
})

export const updateEmailDraftSuccess = (draftUpdatedResponse) => ({
  type: UPDATE_EMAIL_DRAFT_SUCCESS,
  draftUpdatedResponse, // {'draftUpdated': updatedDraft}
})

